import SuggestBlock from "../../../../components/suggest-block";
import { initUserpicLoader } from "../../../../components/userpic-loader/index";
import { initBrandLoader } from "./brand-loader";

onDomReady.then(() => {
  SuggestBlock.init();
  initUserpicLoader();
  initBrandLoader();
});